module.exports = __webpack_public_path__ + "static/media/loading-trek-max.98db1d95.gif";